<template>
  <main class="music page-main">
    <section class="page-heading-wrap">
      <h3 class="page-heading">{{ $t('music.head') }}</h3>
      <div class="package-download">
        <p class="m">{{ $t('music.license.m') }}</p>
        <p class="music-download-all pc">
          <a
            v-if="albumLink"
            ref="albumLink"
            :href="albumLink"
            class="btn btn-fill"
            :download="`[${$t('music.downloadTitle')}] ${$t('music.album.robot.title')}`"
            :class="{
              downloading: downloading
            }"
            @click.prevent="onDownloadAlbum"
          >
            <transition name="loading">
              <loading v-if="downloading" />
            </transition>
            {{ $t('music.downloadAll') }}
          </a>
        </p>
        <!--<share
            :list="['kakaotalk', 'facebook', 'twitter', 'link']"
            :share-image="shareImagePath"
            :description="$t('music.share.description')"
            :title="$t('music.downloadTitle')"
            class="m"
            @click:share="onClickShare"
        />-->
      </div>
    </section>

    <section class="music-album">
      <!--<article class="music-album-info">
        <p>
          &lt;!&ndash;          <picture class="music-album-cover">&ndash;&gt;
          &lt;!&ndash;            <source media="(min-width: 750px)" srcset="~@/static/image/music/pc/robot-fantasia@3x.jpg 3x">&ndash;&gt;
          &lt;!&ndash;            <source media="(max-width: 750px)" srcset="~@/static/image/music/m/robot-fantasia@3x.jpg 3x">&ndash;&gt;
          &lt;!&ndash;            <img src="~@/static/image/music/pc/robot-fantasia.jpg" :alt="$t('vision.name')">&ndash;&gt;
          &lt;!&ndash;          </picture>&ndash;&gt;
          <video
            class="music-album-cover"
            muted
            loop
            autoplay
            playsinline
            poster="~@/static/image/music/pc/robot-fantasia.jpg"
          >
            <source src="~@/static/video/robot_fantasia.mp4" type="video/mp4">
            Sorry, your browser doesn't support embedded videos.
          </video>
        </p>
        <h4>{{ $t('music.album.robot.title') }}</h4>
        <html-view
          :value="$t('music.album.robot.description')"
          class="music-album-desc"
          tag="p"
        />
      </article>-->

      <music-section v-for="(item, key) in musicList" :key="key" :contents="item" />

      <!--<div class="music-next">
        <div class="music-next-description">
          <html-view :value="$t('music.next.description')" tag="p" />
        </div>
        <share
          :list="['kakaotalk', 'facebook', 'twitter', 'link']"
          :share-image="shareImagePath"
          :title="$t('music.share.title')"
          :description="$t('music.share.description')"
          class="pc"
          @click:share="onClickShare"
        />
      </div>-->
    </section>

    <section class="music-license" data-style="default">
      <p class="pc">{{ $t('music.license.note') }}</p>
      <!--      <button type="button" @click="onToggleLicense">-->
      <!--        <span>라이센스 보러가기</span>-->
      <!--        <icon-blank />-->
      <!--      </button>-->
      <router-link :to="{name: 'MusicLicense', params: {locale: $route.params.locale}}">
        <span>{{ $t('music.license.go') }}</span>
        <icon-blank />
      </router-link>
    </section>
  </main>
</template>

<script>
// import albumApi from '@/api/album'
import gtag from '@/mixins/gtag'

export default {
  components: {
    musicSection: () => import('@/views/music/MusicSection.vue'),
    share: () => import('@/components/base/Share'),
    iconBlank: () => import('@/static/svg/blank.svg'),
    loading: () => import('@/components/base/Loading.vue')
  },
  mixins: [gtag],
  data () {
    return {
      downloading: false,
      // shareImagePath: `${process.env.VUE_APP_CDN_PATH}/static/image/music/pc/robot-fantasia.png`,
      // shareImagePath: require('@/static/image/music/pc/robot-fantasia.png'),
      shareImagePath: process.env.NODE_ENV !== 'production' ? 'https://woowahan-cdn.woowahan.com/static/image/music/pc/robot-fantasia.png' : require('@/static/image/music/pc/robot-fantasia.png'),
      musicList: [
        {
          index: 1,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_1.mp3`,
          // mp3: require('@/static/track_MAT_1.mp3'),
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_1.wav`,
          video: '822901775',
          hash: 'f59f6cece5'
        },
        {
          index: 2,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_2.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_2.wav`,
          video: '822911489',
          hash: 'f37fdc49bc'
        },
        {
          index: 3,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_3.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_3.wav`,
          video: '822912725',
          hash: 'c5721b0b80'
        },
        {
          index: 4,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_4.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_4.wav`,
          video: '822913194',
          hash: '58e8c68b89'
        },
        {
          index: 5,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_5.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_5.wav`,
          video: '822913683',
          hash: 'fadfd8e8cd'
        },
        {
          index: 6,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_6.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_6.wav`,
          video: '822914598',
          hash: 'e2249e8453'
        },
        {
          index: 7,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_7.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_7.wav`,
          video: '822915067',
          hash: '113dda17f2'
        },
        {
          index: 8,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_8.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_8.wav`,
          video: '822915365',
          hash: '637f70204c'
        },
        {
          index: 9,
          mp3: `${process.env.VUE_APP_CDN_PATH}/static/music/mp3/track_MAT_9.mp3`,
          wav: `${process.env.VUE_APP_CDN_PATH}/static/music/wav/track_MAT_9.wav`,
          video: '822915642',
          hash: '21e1130862'
        }
      ]
    }
  },
  computed: {
    albumLink () {
      const fileName = this.$route.params.locale === 'en' ? '[Baedal Minjok] Robot Fantasia.zip' : encodeURI('[배민음악] 로봇판타지아.zip')

      return `${process.env.VUE_APP_CDN_PATH}/static/music/${fileName}`
    }
  },
  watch: {
    '$route.params.locale' (v) {
      this.init()
    },
  },
  mounted () {
    this.init()
  },
  methods: {
    init () {
      const trackList = this.$i18n.messages[this.$i18n.locale].music.album.robot.track

        this.musicList = this.musicList.map((v, i) => ({
        ...v,
        ...trackList[i]
      }))

      this.initGtag({
        element: this.$refs.albumLink,
        // isView: true,
        ga: {
          name: '음악_전체 다운로드',
          category: '음악_전체 다운로드',
          label: '음악_전체 다운로드',
          page: '음악'
        }
      })
    },
    onDownloadAlbum (e) {
      // this.downloading = true
      // await albumApi.setAlbum({
      //   // clientIp: '',
      //   contentSeq: 1, // TODO: album seq는 일단 1번만 있음
      //   type: 'ALBUM_DOWNLOAD'
      // })

      this.forceDownload()
    },
    forceDownload () {
      const fileName = this.$route.params.locale === 'en' ? '[Baedal Minjok] Robot Fantasia.zip' : encodeURI('[배민음악] 로봇판타지아.zip')
      const a = document.createElement('a')
      a.download = fileName
      a.href = this.albumLink
      // a.target = '_blank'
      document.body.appendChild(a)
      a.click()
      a.remove()
    },
    onClickShare (e, type) {
      this.setGtag({
        action: 'click',
        name: '음악_공유하기',
        label: type,
        category: '음악_공유하기',
        page: '음악'
      })
    },
  }
}
</script>
